module.exports = __webpack_public_path__ + "fonts/Axiforma-Medium.230a759.ttf";